// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.targeting {
  margin: 1.43rem 0;
}

.targeting__tilte {
  display: flex;
  align-items: center;
  line-height: 1rem;
}

.targeting__tilte svg {
  opacity: 0.5;
  color: var(--palette-gray-7);
  margin-left: 0.5rem;
}

.targeting__criteria {
  display: inline-flex;
  width: 100%;
}
.targeting__criteria > div {
  margin-left: 0.5rem;
}
.targeting__criteria > div:first-child {
  margin-left: 0;
}
.targeting .targeting__criteria-delimiter:first-of-type {
  display: none;
}
.targeting__criteria-delimiter {
  text-align: center;
  margin: 0.875rem 0 0.4375rem;
}
.targeting__criteria-delimiter > span {
  color: var(--palette-gray-8);
  background-color: var(--palette-gray-7-opacity12);
  border-radius: 4px;
  padding: 0.2rem 0.4rem;
  font-size: 11px;
  display: inline-block;
}
.targeting__criteria-select {
  flex: 2;
}
.targeting__criteria-operation {
  flex: 1;
}
.targeting__criteria-operation--full-width {
  flex: 3;
}
.targeting__criteria-value {
  flex: 2;
}
.targeting__criteria .Input .Input__container {
  background-color: inherit;
}
.targeting__criteria-remove {
  flex: 0;
  margin-top: 23px;
}
.targeting__criteria-remove button {
  background-color: var(--palette-thribee-red);
  padding: 4px 0;
  cursor: pointer;
  border-radius: 100%;
  border: none;
  overflow: hidden;
  -webkit-appearance: none;
  width: 24px;
  height: 24px;
}
.targeting__criteria-remove .CrossIcon {
  stroke: currentColor;
  color: var(--palette-thribee-white);
}

.targeting__criteria .TextInput label:not(.Input__label--shrink) {
  transform: translate(10px, 2rem) scale(1);
}

.targeting__criteria .TextInput label.Input__label--shrink {
  transform: translate(13px, 0.57rem) scale(0.75);
}
`, "",{"version":3,"sources":["webpack://./js/components/UnifiedCampaignForm/TargetingForm/TargetingForm.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,4BAA4B;EAC5B,iDAAiD;EACjD,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,OAAO;AACT;AACA;EACE,OAAO;AACT;AACA;EACE,OAAO;AACT;AACA;EACE,OAAO;AACT;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,4CAA4C;EAC5C,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,+CAA+C;AACjD","sourcesContent":[".targeting {\n  margin: 1.43rem 0;\n}\n\n.targeting__tilte {\n  display: flex;\n  align-items: center;\n  line-height: 1rem;\n}\n\n.targeting__tilte svg {\n  opacity: 0.5;\n  color: var(--palette-gray-7);\n  margin-left: 0.5rem;\n}\n\n.targeting__criteria {\n  display: inline-flex;\n  width: 100%;\n}\n.targeting__criteria > div {\n  margin-left: 0.5rem;\n}\n.targeting__criteria > div:first-child {\n  margin-left: 0;\n}\n.targeting .targeting__criteria-delimiter:first-of-type {\n  display: none;\n}\n.targeting__criteria-delimiter {\n  text-align: center;\n  margin: 0.875rem 0 0.4375rem;\n}\n.targeting__criteria-delimiter > span {\n  color: var(--palette-gray-8);\n  background-color: var(--palette-gray-7-opacity12);\n  border-radius: 4px;\n  padding: 0.2rem 0.4rem;\n  font-size: 11px;\n  display: inline-block;\n}\n.targeting__criteria-select {\n  flex: 2;\n}\n.targeting__criteria-operation {\n  flex: 1;\n}\n.targeting__criteria-operation--full-width {\n  flex: 3;\n}\n.targeting__criteria-value {\n  flex: 2;\n}\n.targeting__criteria .Input .Input__container {\n  background-color: inherit;\n}\n.targeting__criteria-remove {\n  flex: 0;\n  margin-top: 23px;\n}\n.targeting__criteria-remove button {\n  background-color: var(--palette-thribee-red);\n  padding: 4px 0;\n  cursor: pointer;\n  border-radius: 100%;\n  border: none;\n  overflow: hidden;\n  -webkit-appearance: none;\n  width: 24px;\n  height: 24px;\n}\n.targeting__criteria-remove .CrossIcon {\n  stroke: currentColor;\n  color: var(--palette-thribee-white);\n}\n\n.targeting__criteria .TextInput label:not(.Input__label--shrink) {\n  transform: translate(10px, 2rem) scale(1);\n}\n\n.targeting__criteria .TextInput label.Input__label--shrink {\n  transform: translate(13px, 0.57rem) scale(0.75);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
